export default function mapStressLevel(val) {
  switch (val) {
    case -1:
      return 'Relaxed'
    case 0:
      return 'Normal'
    case 1:
      return 'Low'
    case 2:
      return 'Medium'
    case 3:
      return 'High'
    case 4:
      return 'Very High'
    case 5:
      return 'Extremely High'
    default:
      return '!'
  }
}
